import styled from 'styled-components';
import { text1 } from '@ardoq/typography';
import { formatNumber } from '@ardoq/locale';
import { DecoratorWrapper } from './atoms';

const NumberCellStyle = styled.div<{ $alignTo: 'left' | 'right' }>`
  ${text1};
  flex: 1;
`;

type NumberDecoratorProps = {
  value: number | string;
  prefix?: string;
  postfix?: string;
  isDecimal?: boolean;
  alignTo?: 'left' | 'right';
  numberFormatOptions?: string;
};

export const NumberDecorator = ({
  prefix,
  postfix,
  value,
  isDecimal,
  alignTo = 'left',
  numberFormatOptions,
}: NumberDecoratorProps) => {
  // Prioritize numberFormatOptions, then fall back to isDecimal
  const formatOptions =
    numberFormatOptions || (isDecimal ? 'decimal' : undefined);

  return (
    <DecoratorWrapper>
      <NumberCellStyle $alignTo={alignTo}>
        {`${prefix || ''} ${formatNumber(
          value as number,
          formatOptions
        )} ${postfix || ''}`.trim()}
      </NumberCellStyle>
    </DecoratorWrapper>
  );
};
